// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-container-model {
  width: 100%;
}
.scrollModel {
  max-height: 350px;
  min-height: 350px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 10px;
  border: none;
}
.nameModel h2 {
  margin-left: 2%;
  color: #21134f;
  font-size: 24px;
}
.cardAllModel {
  margin-top: 3%;
}
.edit {
  display: none;
}
.notShow {
  display: none;
}
.cardModel {
  max-width: 330px;
  min-height: 340px;
}
.textInput {
  background-color: transparent;
  border: 0;
}
.card-text {
  display: flex;
  width: 100% !important;
}
.left-model,
.right-model {
  width: 50%;
}
.left-model {
  float: left;
  margin-left: 5%;
}
.right-model {
  display: flex;
  float: right;
  margin-left: 31%;
}
.btn-model {
  float: right;
  margin-left: 5%;
  color: #b7b7b7;
}
.model-action {
  color: #b7b7b7;
}
.notShowInput {
  display: none;
}
.showInput {
  display: flex;
  width: 100%;
  text-align: center;
}
.newAdd {
  background-color: transparent;
  border: 0;
}
.inputModal {
  display: flex;
  margin-left: 6%;
}
.modelTag {
  border: 0;
  font-size: 15px;
  border-radius: 8px;
  width: 230px;
  height: 30px;
  text-align: center;
  padding-top: 3%;
}
.model_tag {
  border: 0;
  font-size: 15px;
  border-radius: 8px;
  width: 100%;
  height: 30px;
}
.card-model {
  margin-top: 2rem;
}
.edit-model:hover {
  color: #1b4af5;
  cursor: pointer;
}
.delete-model:hover {
  color: #f72d44;
  cursor: pointer;
}
.text-model:hover {
  border-style: solid;
  color: white !important;
  background-color: #E04D8B;
}
.obj-model:hover {
  border-style: solid;
  color: white !important;
  background-color: #218AE7;
}
.scene-model:hover {
  border-style: solid;
  color: white !important;
  background-color: #2EA66C;
}
`, "",{"version":3,"sources":["webpack://./src/views/settings/Model/styles/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAIA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAFF;AAKA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAHF;AAKA;EACE,cAAA;AAHF;AAKA;EACE,aAAA;AAHF;AAMA;EACE,aAAA;AAJF;AAOA;EACE,gBAAA;EACA,iBAAA;AALF;AAQA;EACE,6BAAA;EACA,SAAA;AANF;AASA;EACE,aAAA;EACA,sBAAA;AAPF;AAUA;;EAEE,UAAA;AARF;AAWA;EACE,WAAA;EACA,eAAA;AATF;AAYA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAVF;AAaA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAXF;AAcA;EACE,cAAA;AAZF;AAeA;EACE,aAAA;AAbF;AAgBA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AAdF;AAiBA;EACE,6BAAA;EACA,SAAA;AAfF;AAkBA;EACE,aAAA;EACA,eAAA;AAhBF;AAmBA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAjBF;AAoBA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAlBF;AA6BA;EACE,gBAAA;AA3BF;AA8BA;EACE,cAAA;EACA,eAAA;AA5BF;AA+BA;EACE,cAAA;EACA,eAAA;AA7BF;AAgCA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;AA9BF;AAiCA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;AA/BF;AAkCA;EACE,mBAAA;EACA,uBAAA;EACA,yBAAA;AAhCF","sourcesContent":[".card-container-model {\n  width: 100%;\n  // min-height: 500px;\n  // flex-wrap: nowrap;\n}\n\n.scrollModel {\n  max-height: 350px;\n  min-height: 350px;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 10px;\n  border: none;\n}\n\n.nameModel h2 {\n  margin-left: 2%;\n  color: #21134f;\n  font-size: 24px;\n}\n.cardAllModel {\n  margin-top: 3%;\n}\n.edit {\n  display: none;\n}\n\n.notShow {\n  display: none;\n}\n\n.cardModel {\n  max-width: 330px;\n  min-height: 340px;\n}\n\n.textInput {\n  background-color: transparent;\n  border: 0;\n}\n\n.card-text {\n  display: flex;\n  width: 100% !important;\n}\n\n.left-model,\n.right-model {\n  width: 50%;\n}\n\n.left-model {\n  float: left;\n  margin-left: 5%;\n}\n\n.right-model {\n  display: flex;\n  float: right;\n  margin-left: 31%;\n}\n\n.btn-model {\n  float: right;\n  margin-left: 5%;\n  color: #b7b7b7;\n}\n\n.model-action {\n  color: #b7b7b7;\n}\n\n.notShowInput {\n  display: none;\n}\n\n.showInput {\n  display: flex;\n  width: 100%;\n  text-align: center;\n}\n\n.newAdd {\n  background-color: transparent;\n  border: 0;\n}\n\n.inputModal {\n  display: flex;\n  margin-left: 6%;\n}\n\n.modelTag {\n  border: 0;\n  font-size: 15px;\n  border-radius: 8px;\n  width: 230px;\n  height: 30px;\n  text-align: center;\n  padding-top: 3%;\n}\n\n.model_tag {\n  border: 0;\n  font-size: 15px;\n  border-radius: 8px;\n  width: 100%;\n  height: 30px;\n}\n\n// .scrollModel{\n//   height: 250;\n//   overflow-y: auto;\n//   overflow-x: hidden;\n//   padding: 0 10px;\n//   border: none;\n// }\n\n.card-model {\n  margin-top: 2rem;\n}\n\n.edit-model:hover{\n  color: #1b4af5;\n  cursor: pointer;\n}\n\n.delete-model:hover{\n  color:#f72d44;\n  cursor: pointer;\n}\n\n.text-model:hover{\n  border-style: solid;\n  color:white !important;\n  background-color:  #E04D8B;\n}\n\n.obj-model:hover{\n  border-style: solid;\n  color:white !important;\n  background-color:  #218AE7;\n}\n\n.scene-model:hover{\n  border-style: solid;\n  color:white !important;\n  background-color:  #2EA66C;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
